import { Injectable } from '@angular/core';
import { UssApiService } from '../../uss-toolbox/services/uss-api/uss-api.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { UserProfile } from '../../../models/profile.model';



@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private readonly api: UssApiService,
    public toastrService: ToastrService,
  ) { }

  getUserProfile(userName: string): Observable<UserProfile> {
    return this.api.post('user/get-profile', { userName }).pipe(
      map((res) => res.data),
      catchError((err: HttpErrorResponse) => {
        if (err.error.statusCode === 1050) {
          this.toastrService.error(err.error.message);
        } 
        return [];
      })
    );
  }

  updateUserFavorite(userProfile : UserProfile): Observable<UserProfile> {
    return this.api.post('user/update-favorite',  userProfile).pipe(
      map((res) => res.data),
      catchError((err: HttpErrorResponse) => {
        if (err.error.statusCode === 1050) {
          this.toastrService.error(err.error.message);
        } 
        return [];
      })
    );
  }

  updateUserRoles(userProfile: UserProfile): Observable<UserProfile> {
    return this.api.post('user/update-roles', userProfile).pipe(
      map((res) => res.data),
      catchError((err: HttpErrorResponse) => {
        if (err.error.statusCode === 1050) {
          this.toastrService.error(err.error.message);
        } 
        return [];
      })
    );
  }
}
